import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { definition as faBars } from '@fortawesome/free-solid-svg-icons/faBars';

import { HeaderLogo } from './HeaderLogo';
import { Menu } from './Menu';

import { HeaderDropdown } from './HeaderDropdown';

import type {
  HeaderProps,
} from './types';

const StyledWrapper = styled.div(({
  theme: {
    colors,
    header,
    layout,
  },
}) => ({
  display: 'flex',
  backgroundColor: colors[header.BACKGROUND_COLOR],
  borderBottom: header.BORDER_BOTTOM,
  height: layout.HEADER_HEIGHT,
}));

export const StyledMenuToggler = styled.button(({
  theme: {
    colors,
    grid,
    layout,
  },
}) => ({
  verticalAlign: 'top',
  height: layout.HEADER_HEIGHT,
  width: layout.TOGGLE_BUTTON_WIDTH,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  border: 'none',
  color: colors.ACTION_DEFAULT,
  textAlign: 'center',
  fontSize: 18,
  outline: 'none',

  ':hover': {
    color: colors.ACTION_HOVER,
  },

  ':active': {
    color: colors.ACTION_PRESSED,
  },

  [`@media (min-width: ${grid.SCREEN_WIDTH_MD}px)`]: {
    display: 'none',
  },
}));

export const StyledContent = styled.div(({
  theme: {
    header,
  },
}) => ({
  flex: 1,
  display: 'flex',
  boxSizing: 'border-box',
  paddingLeft: header.CONTENT_OFFSET_LEFT,
  paddingRight: header.CONTENT_OFFSET_RIGHT,
  borderBottom: header.CONTENT_BORDER_BOTTOM,
  overflow: 'hidden',
}));

export const StyledLeftBlock = styled.div({
  flex: 1,
  overflow: 'hidden',
});

export function HeaderBlock({
  logo,
  isUserBlockHidden,
  showAvatar = false,
  avatar = undefined,
  userName,
  dropdownOptions,
  leftBlock = undefined,
  menu = undefined,
  rightMenu = undefined,

  isLogoCollapsible = false,
  menuCollapsed = false,
  collapsible = true,
  openMenu = undefined,
  counters = undefined,
  countersMaxNumber = undefined,
}: HeaderProps): ReactElement {
  return (
    <StyledWrapper>
      {
        collapsible && (
          <StyledMenuToggler
            type="button"
            onClick={openMenu}
          >
            <FontAwesomeIcon
              icon={faBars}
            />
          </StyledMenuToggler>
        )
      }

      <HeaderLogo
        isCollapsed={isLogoCollapsible && menuCollapsed}
        logo={logo}
      />

      <StyledContent>
        <StyledLeftBlock>
          {
            leftBlock || (
              menu && (
                <Menu
                  menu={menu}
                  counters={counters}
                  countersMaxNumber={countersMaxNumber}
                />
              )
            ) || null
          }
        </StyledLeftBlock>

        {rightMenu && (
          <Menu
            right
            menu={rightMenu}
            counters={counters}
            countersMaxNumber={countersMaxNumber}
          />
        )}

        {!isUserBlockHidden && (
          <HeaderDropdown
            showAvatar={showAvatar}
            avatar={avatar}
            userName={userName}
            options={dropdownOptions}
          />
        )}
      </StyledContent>
    </StyledWrapper>
  );
}
